<!-- =========================================================================================
  File Name: FullPage.vue
  Description: Full page layout
  ----------------------------------------------------------------------------------------
  Item Name: FullPage
  Author: Tan Hoang Duy Tran
========================================================================================== -->


<template>
  <a-layout>
    <app-header/>
    <a-layout-content>
      <router-view></router-view>
    </a-layout-content>
    <app-footer/>
  </a-layout>
</template>

<script>
import AppHeader from './components/AppHeaderFullPage.vue'
import AppFooter from './components/AppFooter.vue'

export default{
  components : {
    AppHeader,
    AppFooter
  }
}
</script>
